import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=5570acc9"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js"
import style0 from "./AccountChangePassword.vue?vue&type=style&index=0&id=5570acc9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports